import {
  McpSnapshotAssetAccessSchema,
  type McpSnapshotAssetAccessDto,
} from './mcp-servers.schema';

export const readMcpComponentAssetAccess = (
  metadata: unknown,
): McpSnapshotAssetAccessDto => {
  const meta = metadata as Record<string, unknown> | null;
  if (!meta) {
    return {};
  }

  const parsed = McpSnapshotAssetAccessSchema.safeParse({
    identityAccess: meta.identityAccess,
    accessScope: meta.accessScope,
  });

  return parsed.success ? parsed.data : {};
};
